import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_CHEVRON_UP: GlameraIconDefinition = {
  name: 'circle-chevron-up',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-circle-chevron-up-circle" cx="12" cy="12" r="10"></circle>
    <path class="glm-circle-chevron-up-arrow" d="m8 14 4-4 4 4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-chevron-up-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-chevron-up.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleChevronUpIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_CHEVRON_UP;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
